import Component, { mixins } from 'vue-class-component'

import { AxiosError, AxiosResponse } from 'axios';
import HttpStatusCode from 'http-status-codes'

import WithRender from './App.html'

import { 
  MDialog,
  MDialogState,
  MDialogWidth
} from '@ulaval/modul-components';

import InscriptionLieuExamenService from '@/modules/inscription-lieu-examen/InscriptionLieuExamen.service';

import Localization from '@/localization';
import ROUTES from './router/ROUTES';
import { generateLocalizedRouteName } from '@/router/helpers';
import { STORE_ACTIONS, STORE_GETTERS } from './store';
import { Watch } from 'vue-property-decorator';
import { LOCAL_STORAGE_KEY_AUTHORIZATION_TOKEN, LOCAL_STORAGE_KEY_TOKEN } from './modules/global/user-session/UserSession.store';

const HTTP_STATUS_TO_REDIRECT: string[] = [
  HttpStatusCode.INTERNAL_SERVER_ERROR.toString(),
  HttpStatusCode.FORBIDDEN.toString(),
  HttpStatusCode.UNAUTHORIZED.toString()
]

@WithRender
@Component({
  components: {
    MDialog
  }
})
export default class App extends mixins(InscriptionLieuExamenService) {
  private isDialogMessageImportantActive: boolean = false
  private readonly MDialogState: object = MDialogState
  private readonly MDialogWidth: object = MDialogWidth
  
  private get messageImportantGlobal(): string | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_MESSAGE_IMPORTANT]
  }

  @Watch('messageImportantGlobal')
  private onMessageImportantGlobalChange(): void {
    this.isDialogMessageImportantActive = !!this.messageImportantGlobal
  }
  
  private created(): void {
    this.$store.dispatch(STORE_ACTIONS.SESSION_STORE_SYNCHRONISE_WITH_LOCAL_STORAGE)
    this.fetchInformations()
    this.setAxiosBasicHeaders()
    this.updateStudentTokenLocalStorage()
  }

  private mounted(): void {
    document.title = this.$i18next.t('localization.main.website_title')
    this.$store.dispatch(STORE_ACTIONS.SESSION_STORE_SYNCHRONISE_WITH_LOCAL_STORAGE)
    this.setAxiosBasicHeaders()
  }

  private updated(): void {
    this.setAxiosBasicHeaders()
    this.updateStudentTokenLocalStorage()
  }

  private setAxiosBasicHeaders(): void {
    const sessionToken: string | null = localStorage.getItem(LOCAL_STORAGE_KEY_AUTHORIZATION_TOKEN)

    if (sessionToken) {
      this.$axios.defaults.headers.common.Authorization = `Bearer ${sessionToken}`
    }
  }

  private fetchInformations(): void {
    this.service_inscriptionLieuExamenService_fetchInformations()
  }

  private updateStudentTokenLocalStorage(): void {
    const token: string = this.$route.params.token

    if (token) {
      localStorage.setItem(LOCAL_STORAGE_KEY_TOKEN, token)
    }
  }
}
